import { Outlet, useNavigate } from "react-router-dom";
import { getToken, removeToken } from "../shared/helpers/localstorage-helper";
import { useEffect } from "react";

interface ProtectedRouteProps {
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const navigate = useNavigate();
  const token = getToken();

  useEffect(() => {
    if (token === null) {
        removeToken();
        navigate("/", { replace: true });
    }
  }, [token, navigate]);
  
  if (token === null) {
    return null;
  }

  return <Outlet />;
};

export default ProtectedRoute;
